export default {
    'Tutor': 'Tutor',
    'Lesson_booked': 'Lesson is booked',
    'Group': 'Group',
    'Format': 'Format',
    'Link_making_lesson': 'Link for a making up lesson',
    'Comment': 'Comment',
    'Phone': 'Phone',
    'Close': 'Close',
    'Cancel_your_booking': 'Cancel your booking',
    'Making_lessons': 'Making up of lessons',
    'You_make_missed_classes': 'You have to make up missed classes.',
    'Select_free_time_slots': 'Select free time slots and click the "Book a making up class" <br/> button to make an appointment with a tutor.',
    's_week': 'Specify a week',
    'Book_up_lesson': 'Book a making up lesson',
    'The_lesson_booked': 'The lesson is booked',
    'Lesson': 'Lesson',
    'Booked': 'Booked',
    'worked': 'worked out',
    'Select_least_time': 'You are to select at least one time cell.',
    'Period_successfully_removed': 'Period has been successfully removed.',
    'no_possibility_3_blank_spaces': 'You have no possibility to pick more than 3 blank spaces.',
    'no_possibility_3_classes_per_day': 'You have no possibility of making up more than 3 classes per day.',
    'no_more_classes_left': 'You have no make-up classes left.',
    'Successfully': 'Successfully',
    'Date':'Date',
    'Time':'Time',
    'Program':'Program',
    'Save': 'Save',
    'Book_making_lesson': 'Book a making up lesson',
    'class_missed':'Class Missed',
    'offline_class':'Offline Class',
    'online_class':'Online Class',
    'show_more': 'Show more',
    'groups_list': 'Groups List',
    'messages': 'Messages',
    'Good': 'Good',
    'Days': 'Days',
    'Hours': 'Hours',
    'Minutes': 'Minutes',
    'Seconds': 'Seconds',
    'Access to the lesson will be closed through:': 'Access to the lesson will be closed through:',
};
